export default __webpack_public_path__ + "static/media/bg-character.5e2df7cb.png";